export const DEFAULT_ALPHA = 0.05;

export function getColorForPValue(value: number, { alpha }: { alpha: number }) {
    const pValue = parseFloat(String(value));
    if(!pValue) {
      return null;
    }

    let color = 'green';
    if(pValue > 0.01 && pValue <= alpha) {
      color = 'orange';
    } else if (pValue < 0.01) {
      color = 'red';
    }

    return color;
}
